import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-f6942cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll_data" }
const _hoisted_2 = { class: "error-tip" }
const _hoisted_3 = { class: "left bg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-link" }, null, -1))
const _hoisted_5 = { class: "right bg err-bg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bias-line" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "ws_drawer_footer" }

import { ref, watch, nextTick, computed } from 'vue'
import { queryProductSubDeviceList, queryProductBusType } from '@/api'
import { CODE_ENUM, PRODUCT_TYPE } from '@/common'
import { cloneDeep, isEmpty } from 'lodash'
import { validateSubDevices } from '@/utils'

const MAX_COUNT = 50

export default /*#__PURE__*/_defineComponent({
  __name: 'sub-device-form-drawer',
  props: ['visible', 'data', 'productType'],
  emits: ['update:visible', 'on-change'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      querySubDevice()

      // 多模才需要查询总线类型
      if (!isSingleGateaway.value) {
        queryBusType()
      }
      if (!isEmpty(props.data)) {
        formData.value.subDevices = cloneDeep(props.data)
      }
    } else {
      formRef.value.resetFields()
    }
  }
)

const isSingleGateaway = computed(() => {
  return props.productType === PRODUCT_TYPE.SINGLE_GATEWAY
})

const formRef = ref()

const showMinus = () => {
  const len = formData.value.subDevices.length
  return len !== 1
}

const showMax = (index: number) => {
  const len = formData.value.subDevices.length
  return (index === len - 1 && len < MAX_COUNT) || len === 1
}

const formData: any = ref({
  subDevices: [
    {
      productKey: '',
      busType: '',
      busId: '',
      sensorId: '',
      deviceSnAlias: '',
    },
  ],
})

const scrollIndex = (index: number) => {
  const scrollEl: any = document.body.querySelector('.scroll_box')
  const el: any = document.body.querySelectorAll('.box')[index]
  const top = el.offsetTop
  scrollEl.scrollTop = top
}

const getRepeatIndex = () => {
  const flagList = formData.value.subDevices.map((item: any, index: number) => {
    return validateSubDevices(
      index,
      formData.value.subDevices,
      props.productType
    )
  })
  return flagList.indexOf(true)
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      // 校验重复表单
      const repeatIndex = getRepeatIndex()
      if (repeatIndex >= 0) {
        scrollIndex(repeatIndex)
        return
      }

      $emit('on-change', cloneDeep(formData.value.subDevices))
      handleClose()
    }
  })
}

const reduce = (index: number) => {
  formData.value.subDevices.splice(index, 1)
}

const increase = () => {
  formData.value.subDevices.push({
    productKey: '',
    busType: '',
    busId: '',
    sensorId: '',
    deviceSnAlias: '',
  })

  nextTick(() => {
    const scrollEl: any = document.body.querySelector('.scroll_box')
    const el: any = document.body.querySelector('.scroll_data')
    const h = el.offsetHeight
    scrollEl.scrollTop = h
  })
}

const validateBus = (index: number, value: any) => {
  const busType = formData.value.subDevices[index].busType
  const children =
    busList.value.filter((item: any) => item.value === busType)?.[0]
      ?.children || []
  const childrenIds = children.map((item: any) => item.code)

  return {
    valid: childrenIds.length === 0 || childrenIds.includes(value),
    msg: '可选值为:' + childrenIds.join('、'),
  }
}

const getBusValidator = (index: number) => {
  return (rule: any, value: any, callback: any) => {
    const { valid, msg } = validateBus(index, value)
    valid && callback()
    !valid && callback(msg)
  }
}

const subDeviceList: any = ref([])
const querySubDevice = async () => {
  const res: any = await queryProductSubDeviceList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    subDeviceList.value = res.data.map(
      ({ productKey, productName, producer, productModel }: any) => {
        const label = [productName, producer, productModel]
          .filter(Boolean)
          .join('/')
        return {
          value: productKey,
          label,
        }
      }
    )
  }
}

const busList: any = ref([])
const queryBusType = async () => {
  const res: any = await queryProductBusType()
  if (res?.code === CODE_ENUM.SUCCESS) {
    busList.value = res.data.map(({ name, code, busIdVOS }: any) => {
      return {
        value: code,
        label: name,
        children: busIdVOS,
      }
    })
  }
}
const handleClose = () => {
  $emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: "关联子设备",
    size: "1070px",
    "before-close": handleClose,
    class: "sub-device-form-modal",
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_9, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        "label-width": 1,
        "hide-required-asterisk": "",
        class: "data scroll_box"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.subDevices, (domain, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["box", {
            error: _unref(validateSubDevices)(
              index,
              formData.value.subDevices,
              props.productType
            ),
          }]),
                key: index
              }, [
                _withDirectives(_createElementVNode("span", _hoisted_2, "端口号重复", 512), [
                  [_vShow, 
              _unref(validateSubDevices)(index, formData.value.subDevices, props.productType)
            ]
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, {
                    prop: 'subDevices.' + index + '.productKey',
                    rules: {
                required: true,
                message: '请选择',
                trigger: 'change',
              },
                    class: "left-form-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: domain.productKey,
                        "onUpdate:modelValue": ($event: any) => ((domain.productKey) = $event),
                        class: "ws_select",
                        placeholder: "请输入产品名/厂家/型号",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subDeviceList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (!isSingleGateaway.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: 'subDevices.' + index + '.busType',
                        rules: {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
                        class: "right-form-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: domain.busType,
                            "onUpdate:modelValue": ($event: any) => ((domain.busType) = $event),
                            class: "ws_select",
                            placeholder: "请输入总线类型",
                            filterable: "",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(busList.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop"]))
                    : _createCommentVNode("", true),
                  (!isSingleGateaway.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: 'subDevices.' + index + '.busId',
                        rules: [
                {
                  required: true,
                  message: '请输入',
                  trigger: 'change',
                },
                { validator: getBusValidator(index) },
              ],
                        class: "right-form-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: domain.busId,
                            "onUpdate:modelValue": ($event: any) => ((domain.busId) = $event),
                            placeholder: "请输入总线ID"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    prop: 'subDevices.' + index + '.sensorId',
                    rules: {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
                    class: "right-form-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: domain.sensorId,
                        "onUpdate:modelValue": ($event: any) => ((domain.sensorId) = $event),
                        placeholder: "请输入传感器ID"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"]),
                  _hoisted_6,
                  _createVNode(_component_el_form_item, {
                    prop: 'subDevices.' + index + '.deviceSnAlias',
                    class: "right-form-item-sn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: domain.deviceSnAlias,
                        "onUpdate:modelValue": ($event: any) => ((domain.deviceSnAlias) = $event),
                        placeholder: "传感器SN（非必填）",
                        maxLength: "32"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                _createElementVNode("div", {
                  class: "icon-reduce ws_ml15",
                  onClick: ($event: any) => (reduce(index))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Minus, { color: "#fff" })
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_7)
              ], 2))
            }), 128)),
            (formData.value.subDevices.length <= MAX_COUNT)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: increase,
                  type: "text"
                }, {
                  icon: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 增加子设备 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})